function isFileLike(pathname: string) {
  return /\.\w+$/.test(pathname);
}

function isWellKnown(pathname: string) {
  return pathname.startsWith('/.well-known/');
}

export function needsTrailingSlash(pathname: string) {
  return (
    !pathname.endsWith('/') && !isFileLike(pathname) && !isWellKnown(pathname)
  );
}

export function appendTrailingSlash(pathname: string) {
  return needsTrailingSlash(pathname) ? `${pathname}/` : pathname;
}
